import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
// hooks
import useAuth from '../hooks/useAuth';

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isWebVersion, role } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if ( !isWebVersion() && isAuthenticated && role === "GUEST" ) {
    return <Navigate to="/auth/login" />;
  }

  if ( !isAuthenticated || isWebVersion() && isAuthenticated && role !== "GUEST" ) {
    if ( isWebVersion() ) {
      return <Navigate to="/auth/login-web" />;
    }

    return <Navigate to="/auth/login" />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}

